import React, { useState } from 'react';
import { OrderComponent, SelectInput } from '../../../Components';
import Tshirt from '../../../Assets/Photos/tshirt.png';
import { useParams } from 'react-router';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import './index.css';

const Index = () => {
    const params = useParams();
    const [rowPerPage, setRowPerPage] = useState(10);
    return (
        <div className="product_view_all">
            <div className="product_view_all_head">
                <h2>{params.type.replace(/%/g, ' ')}</h2>
            </div>
            <div className="product_view_all_container">
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
                <OrderComponent image={Tshirt} text="Lorem Ipsum Tshirt" />
            </div>
            <div className="pagination_footer">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SelectInput
                        marginZero
                        style={{ minWidth: '30px' }}
                        label="Items per page:"
                        value={rowPerPage}
                        changeHandler={(e) => {
                            setRowPerPage(e.target.value);
                        }}
                        options={[
                            { name: '10', value: 10 },
                            { name: '25', value: 25 },
                            { name: '50', value: 50 },
                        ]}
                    />
                </div>
                <div className="pagination_footer_pageinfo">
                    <p className="page_details">1-6 of 6</p>
                    <div>
                        <ChevronLeftIcon className={`footer_pagination_icon disabled`} />
                        <ChevronRightIcon className={`footer_pagination_icon`} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
